import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import {  useLocation } from "react-router-dom";
import AyurvedaFooter from './AyurvedaFooter/AyurvedaFooter';
import Tern_nav from './Tern_nav';
import ScrollTop from "./ScrollTop";
export default function Terms_condition() {
    const location = useLocation();

    const isTreatmentActive =
    location.pathname.startsWith("/treatment") ||
    location.pathname.startsWith("/postnatal") ||
    location.pathname.startsWith("/rejuvenation") ||
    location.pathname.startsWith("/hair") ||
    location.pathname.startsWith("/lifecycle") ||
    location.pathname.startsWith("/Soundarya");
  return (
    <>
       <ScrollTop/>
    <Tern_nav/>
      {/* Center Content */}
      <div style={{backgroundColor:'#f7f0d3',paddingLeft:'50px'}} >
        <br/>
      
       <h6>Inpatient Services – Terms & Conditions</h6>
       <p>• Includes all prescribed treatments, internal and external medicines, room rent, and diet food 
            for the mother as per the recommended dietary plan.<br/> 
            • Any medicines required after completion of the treatment package will be billed separately. <br/>
            • All-time meals will be provided for one bystander. <br/>
            • Laundry services are complimentary for the mother, baby, and one accompanying bystander </p>
       <h6 className='mt-4'>Home Care Services – Terms & Conditions </h6>
       <p>• Transportation charges will be applicable and billed separately. <br/>
            • All prescribed medicines will be provided by the clinic during the treatment period. 
            Medicines required after completion of the package or post-treatment will be charged 
            additionally. <br/>
            • The therapist will prepare the medicines as needed, but the patient’s family is responsible 
            for arranging a suitable setup at home <br/>
            • Qualified Ayurvedic Panchakarma therapists will be assigned solely for administering 
            prescribed Ayurvedic treatments. <br/>
            • Therapists will not be responsible for any domestic services, including cooking, laundry, 
            housekeeping, or babysitting. <br/>
            • Shirodhara and Kashayadhara therapies are available only at the clinic and are not included 
            in Home Care Services. </p>
            <h6 className='mt-4'>Day Care Patient Services – Terms & Conditions </h6>
            <p>• The patient may visit the clinic on a daily basis for treatment, as advised by the attending 
            Ayurvedic physician. <br/>
            • All treatments will be provided strictly as per the consultation and treatment protocol 
            prescribed by the attending Ayurvedic physician.<br/> 
            • All prescribed medicines will be provided by the clinic during the treatment period. <br/>
            Medicines required after completion of the package or post-treatment will be charged 
            additionally. <br/>
            • Complimentary laundry is available only for admitted patients, not for daily postnatal visits.</p>
            <br/><br/><br/>
      </div>
      <AyurvedaFooter/>
    </>
  )
}
